import { DOORS } from '@core/Constants/Filters/DoorsFilter.constants';
import { SEATS } from '@core/Constants/Filters/SeatsFilter.constants';
import { MULTISELECT_FILTERS, RANGE_FILTERS } from '@core/Services/Search/Filters.constants';

export const getSlugFilterStructure = () => {
  return {
    'body-type': MULTISELECT_FILTERS['body-type'].map(filterObj => filterObj.id),
    'fuel-type': MULTISELECT_FILTERS.fuelType.map(filterObj => filterObj.id),
    price: RANGE_FILTERS.price.map(filterVal => `under-${filterVal}`),
    'gear-box': MULTISELECT_FILTERS.gearBox.map(filterObj => filterObj.id),
    color: MULTISELECT_FILTERS.color.map(filterObj => filterObj.id),
    doors: Object.keys(DOORS).map(filterVal => `${filterVal}-door`),
    seats: Object.keys(SEATS).map(filterVal => `${filterVal}-seats`),
    badge_engine_cc: RANGE_FILTERS.badge_engine_cc.map(filterVal => `${filterVal.toFixed(1)}l`),
    //NOTE: page needs to be handled separately because there is no finite possible values
    page: [] as string[],
  };
};
